import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-patient-detail-charts',
  templateUrl: './charts.component.html',
  styleUrls: ['./charts.component.scss']
})
export class ChartsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
